<div id="cellarAddPopup" fxLayout="column">
  <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
    <h1>ویرایش امتیاز کاربر</h1>

    <div class="d-flex align-items-center gap-3">
      <!-- <button
        [disabled]="(!isEditMode && pointer) || target !== 'binding'"
        (click)="deleteBinding()"
        color="warn"
        mat-button
      >
        <span>حذف آیتم</span>
        <jam-icon name="remove" vertical-align="middle"></jam-icon>
      </button> -->

      <button
        (click)="submitForm()"
        mat-raised-button
        color="primary"
        [disabled]="!form.valid"
      >
        <jam-icon
          *ngIf="form?.controls?.['operation']?.value === 'paid'"
          name="minus"
          vertical-align="middle"
        />
        <jam-icon
          *ngIf="form?.controls?.['operation']?.value === 'received'"
          name="plus"
          vertical-align="middle"
        />
        {{form?.controls?.['operation']?.value === 'paid' ? 'کاهش' : 'افزایش'}}
        امتیاز
      </button>

      <jam-icon
        name="close"
        class="close-btn mr-3"
        color="warn"
        mat-dialog-close
        vertical-align="middle"
      />
    </div>
  </mat-toolbar>
  <div class="container my-4">
    <form [formGroup]="form" class="row">
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>نام انگلیسی امتیاز</mat-label>
        <mat-select placeholder="وضعیت" formControlName="operation">
          <mat-option value="received">افزودن امتیاز</mat-option>
          <mat-option value="paid">کسر امتیاز</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>دلیل</mat-label>
        <input
          placeholder="دلیل"
          formControlName="reason"
          type="text"
          matInput
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>مقدار امتیاز</mat-label>
        <input
          placeholder="عدد"
          formControlName="score"
          type="text"
          dir="ltr"
          matInput
        />
      </mat-form-field>
    </form>
  </div>
</div>
